import React, { Component } from "react";
import ExperienceCard from "../experience/ExperienceCard";

class ExperianceSection extends Component {
  render() {
    return (
      <section
        className="resume-section p-3 p-lg-5 d-flex justify-content-center"
        id="experience"
      >
        <div className="w-100" style={{ padding: "10px" }}>
          <h2 className="mb-5">Experience</h2>
          <ExperienceCard
            title="Software Engineer - Full Stack Developer"
            company="Acentura Inc (Pvt) Ltd"
            details={`➼ Engineered and maintained scalable Java and Spring Boot microservices for multiple enterprise-grade platforms serving Dialog Axiata, enhancing customer service, operations, and order management.
➼ Built dynamic, user-centric front-end applications using React, enabling efficient interactions for internal CRM and order processing systems.
➼ Proficient in building scalable, maintainable web applications using React.js and modern JavaScript (ES6+).
➼ Experienced with state management libraries such as Redux and Context API for efficient data flow.
➼ Skilled in creating responsive UIs with Material UI, Tailwind CSS, and styled-components.
➼ Familiar with React Router for SPA navigation and dynamic routing.
➼ Integrated RESTful APIs and GraphQL endpoints for robust data handling.
➼ Implemented unit and integration testing using Jest and React Testing Library.
➼ Applied best practices in code reviews, component reusability, and performance optimization.
➼ Experience with Next.js for server-side rendering and static site generation.
➼ Knowledge of CI/CD pipelines, Git version control, and agile development workflows.
➼ Designed, wrote, and optimized Oracle PL/SQL stored procedures, functions, and triggers to support high-performance transaction processing.
➼ Developed and integrated SOAP web services to facilitate real-time communication and data synchronization between internal systems and third-party platforms.
➼ Automated end-to-end testing using Selenium, reducing manual QA workload and improving release confidence.
➼ Implemented Kafka-based messaging pipelines for real-time event streaming, enhancing system scalability and responsiveness.
➼ Utilized GitLab for version control and CI/CD pipelines, supporting automated deployments and collaborative development workflows.
➼ Used Docker to containerize services, ensuring consistency across development, testing, and production environments.
➼ Developed a cloud-native logistics and inventory system tailored for the tea industry, leveraging full-stack technologies.
➼ Built and deployed backend services using Node.js, Serverless Framework, MySQL, and AWS Lambda, with secure secret handling via AWS Secrets Manager.
➼ Developed responsive and dynamic UIs with Next.js, React, MUI (Material UI), and styled components using TailWind CSS.
➼ Implemented complex CRUD operations and real-time dashboards with Redux Toolkit and Axios.
➼ Integrated frontend with backend using AWS Amplify for seamless deployment and scalability.
➼ Enabled real-time tracking of tea lots, blending, packing, delivery orders, and warehouse operations through a robust, scalable architecture.`}
            timeFrom="December 2024"
            timeTo="Present"
          />

          <ExperienceCard
            title="Software Engineer - Full Stack Developer"
            company="Wenthura Solutions (Pvt) Ltd"
            details={`➼ Built scalable and responsive web applications using the MERN stack (MongoDB, Express.js, React, Node.js) and developed microservices with Spring Boot.
➼ Proficient in building scalable, maintainable web applications using React.js and modern JavaScript (ES6+).
➼ Experienced with state management libraries such as Redux and Context API for efficient data flow.
➼ Skilled in creating responsive UIs with Material UI, Tailwind CSS, and styled-components.
➼ Familiar with React Router for SPA navigation and dynamic routing.
➼ Integrated RESTful APIs and GraphQL endpoints for robust data handling.
➼ Implemented unit and integration testing using Jest and React Testing Library.
➼ Applied best practices in code reviews, component reusability, and performance optimization.
➼ Experience with Next.js for server-side rendering and static site generation.
➼ Knowledge of CI/CD pipelines, Git version control, and agile development workflows.
➼ Designed and implemented SQL databases, ensuring efficient data storage, retrieval, and manipulation while maintaining data integrity across complex systems.
➼ Created robust RESTful APIs to facilitate seamless communication within distributed systems and foster efficient integration in microservices architecture.
➼ Developed new learning content using Spring Boot microservices, integrated with top LMS through LTI standards, and deployed components on JBoss application servers for scalability and reliability.
➼ Enhanced code quality by resolving code smells, increasing unit testing coverage to over 90%, and improving application performance and security.
➼ Introduced responsive UI capabilities for LMS using ReactJS, JavaScript, and CSS to deliver an engaging user experience.
➼ Collaborated with internal and external teams, negotiating with stakeholders to resolve conflicting system requirements and ensure project alignment.
➼ Played a key role in migrating the Tea Estate Management System from a NoSQL database (MongoDB) to a SQL database (MySQL), ensuring data integrity and optimized system performance.
➼ Created comprehensive design documents for new features and systems to support development, improve maintainability, and align technical implementations with business requirements.`}
            timeFrom="March 2023"
            timeTo="November 2024"
          />

          <ExperienceCard
            title="Associate Software Engineer - Full Stack Developer"
            company="Wenthura Solutions (Pvt) Ltd"
            details={`➼ Designed and developed robust RESTful APIs using Spring Boot to enable seamless communication in distributed systems, optimizing microservices integration and data exchange.
              ➼ Implemented responsive and dynamic user interfaces with React and Angular 16, delivering an engaging user experience and ensuring cross-platform compatibility.
              ➼ Provided technical solutions to complex problems and conducted peer code reviews, ensuring code quality and adherence to best practices.
              ➼ Followed Agile methodologies for efficient development, testing, and deployment processes, improving team collaboration and delivery timelines.
              ➼ Increased unit test coverage by identifying and resolving code bugs, enhancing software reliability and maintainability.
              ➼ Worked extensively with AWS services such as Windows EC2, SQS, Lambda, and CloudWatch, ensuring scalable, secure, and efficient cloud-based solutions.
              ➼ Actively contributed to maintaining high-quality code by implementing SonarQube-based code analysis to reduce technical debt and improve performance.
              ➼ Leveraged CI/CD pipelines to automate deployment processes, ensuring faster delivery and minimizing downtime.
              ➼ Collaborated with cross-functional teams to design and implement technical architectures that meet business objectives.`}
            timeFrom="March  2023 "
            timeTo="December  2023"
          />
          <ExperienceCard
            title="Software Engineer Trainer"
            company="IFS R&D International Technology - DevEx"
            details={`➼ Designed and implemented a framework enabling users to build SQL queries through an intuitive user interface, leveraging PL/SQL and Angular.
              ➼ Automated security vulnerability detection and resolution with custom pipelines.
              ➼ Maintained and enhanced Custom Fields Framework and IFS Solution Manager functionalities, including Configurations, Custom Objects, and Background Processing.
              ➼ Supported API integration with platforms like Dell Boomi, Power Apps, and Logic Apps.
              ➼ Addressed 3rd-line technical issues, resolving bugs and improving IFS Admin functionalities.
              ➼ Expertise in Docker, Kubernetes, REST APIs, Oracle Database, Java, and PL/SQL.`}
            timeFrom="Jan 2022 "
            timeTo="May 2023"
          />
          <ExperienceCard
            title="Committee Member"
            company="MS Club of SLIIT"
            details="I am a committee member in the main student body of the faculty of computing. I directly involved with 
                        all the events organized by faculty of computing throughout the year."
            timeFrom="January 2022"
            timeTo="February 2023"
          />
        </div>
      </section>
    );
  }
}

export default ExperianceSection;
